export enum DISTANCE_UNIT {
  KILOMETER = 'km',
  MILE = 'mi',
}
